export function parseJSON<T>(body: string): T {
    // Даже если получили пустой ответ, то все равно
    // считаем body валидным типом T, так как запрос мог быть
    // типизирован примерно так: request<JsonResult | undefined>()
    // Такой кейс возникает, например, когда API может отвечать кодом 204 с пустым body.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- см. выше
    return body.length > 0 ? JSON.parse(body) : (undefined as T);
}
